/** Browser path that opens a note: HTML GET redirects home with `?note=`. */
export function noteLinkPath(id: number): string {
  return `/notes/${id}`
}

/** Note id from the home page query, or null when the URL is not that deep link. */
export function noteIdFromUrl(url: string): number | null {
  const parsed = new URL(url, "http://localhost")
  if (parsed.pathname !== "/") return null
  const raw = parsed.searchParams.get("note")
  if (raw == null || !/^[1-9]\d*$/.test(raw)) return null
  return Number(raw)
}

/** Same URL with the one-shot `note` query removed. */
export function urlWithoutNoteParam(url: string): string {
  const parsed = new URL(url, "http://localhost")
  parsed.searchParams.delete("note")
  const query = parsed.searchParams.toString()
  return `${parsed.pathname}${query ? `?${query}` : ""}${parsed.hash}`
}
